var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelStatSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 100,
    viewBox: "0 0 552 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 50.5545C1 50.5545 25.7804 53.7253 39.9805 64.3322C54.1807 74.9391 62.4297 77.968 62.4297 77.968C62.4297 77.968 93.0646 97.763 117.124 76.0592C141.183 54.3553 157.788 36.7609 157.788 36.7609C157.788 36.7609 184.868 14.6979 213.438 36.7609C242.008 58.8239 253.313 65.8015 253.313 65.8015C253.313 65.8015 273.765 79.9681 305.434 68.269C337.103 56.5698 342.433 53.8265 342.433 53.8265C342.433 53.8265 372.209 44.8707 397.041 56.5698C421.873 68.269 441.255 72.3128 441.255 72.3128C441.255 72.3128 470.102 78.6367 483.954 60.8697C497.806 43.1026 526.567 -2.09889 551 1.16819C550.902 18.8615 550.967 75.4518 550.992 94.0292C550.996 97.3464 548.308 100 544.991 100H6.99999C3.68629 100 1 97.3137 1 94V50.5545Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50.4229C1 50.4229 25.7804 53.5853 39.9805 64.164C54.1807 74.7427 62.4297 77.7636 62.4297 77.7636C62.4297 77.7636 93.0646 97.506 117.124 75.8598C141.183 54.2136 157.788 36.6659 157.788 36.6659C157.788 36.6659 184.868 14.6615 213.438 36.6659C242.008 58.6703 253.313 65.6294 253.313 65.6294C253.313 65.6294 273.765 79.7584 305.434 68.0903C337.103 56.4222 342.433 53.6862 342.433 53.6862C342.433 53.6862 372.209 44.7542 397.041 56.4222C421.873 68.0903 441.255 72.1234 441.255 72.1234C441.255 72.1234 470.102 78.4305 483.954 60.7106C497.806 42.9908 526.567 -2.09066 551 1.16775",
    stroke: "#00CB65",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1,
    y1: 1,
    x2: 1,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelStatSuccess);
export default __webpack_public_path__ + "static/media/panel-stat-success.7e861b0f9f896fc7558df1110fed7997.svg";
export { ForwardRef as ReactComponent };